<!-- 项目子项 -->
<template>
  <complete-table ref="table" :style="{ height: wrapHeight.height, width: wrapHeight.width }"> </complete-table>
</template>

<script>
import Sortable from "sortablejs";
import { getListConfigJSON } from "@/CommonDP/service/listFlow-service";
const cacheTableOptions = {};
export default {
  name: "JyhtTablePreview",
  componentName: "ContainerWidget",
  props: {
    widget: {
      type: Object,
      default() {
        return {};
      }
    },
    isPreviewState: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },

  data() {
    return {
      designState: true,
      rawRelateId: "",
      wrapHeight: {
        height: "",
        width: ""
      },
      isMounted: false,
      afterMountedExecutoryFn: []
    };
  },
  computed: {
    customClass() {
      return this.widget.options.customClass || "";
    }
  },

  watch: {
    "widget.options.relateId": {
      async handler(val) {
        console.log("handler", cacheTableOptions, cacheTableOptions[val], val);
        const options = cacheTableOptions[val];
        if (val && options) {
          if (this.$refs.table) {
            this.$refs.table.expose_preview(options);
          } else if (!this.$refs.table) {
            console.log(this.isMounted, "this.isMounted");
            this.afterMountedExecutoryFn.push(() => this.$refs.table.expose_preview(options));
          }
          this.widget.options.tableBtnList =
            options.formOptions?.map((item) => {
              return {
                label: item.tagAttrs.value,
                btnId: item.btnId,
                btnType: item.extraOption.btnType
              };
            }) || [];
        } else if (val && !options) {
          this.widget.options.tableBtnList = [];
          console.log(val, "widget.options.relateId");
          const res = await getListConfigJSON(val);
          const { data: json } = res;
          const options = JSON.parse(json);
          cacheTableOptions[val] = options;
          const { formOptions } = options;
          console.log(res, "commonRender res");
          console.log(formOptions, "commonRender formOptions");
          this.widget.options.tableBtnList =
            formOptions?.map((item) => {
              return {
                label: item.tagAttrs.value,
                btnId: item.btnId,
                btnType: item.extraOption.btnType
              };
            }) || [];
          if (this.$refs.table) {
            this.$refs.table.expose_preview(options);
          } else if (!this.$refs.table) {
            console.log(this.isMounted, "this.isMounted");
            this.afterMountedExecutoryFn.push(() => this.$refs.table.expose_preview(options));
          }
        }
      },
      immediate: true
    },
    "widget.options.tableHeight": {
      async handler(val) {
        this.wrapHeight.height = this.formatterWidthOrHeightStyle(val, true) || "600px";
      },
      immediate: true
    },
    "widget.options.tableWidth": {
      async handler(val) {
        this.wrapHeight.width = this.formatterWidthOrHeightStyle(val) || "100%";
      },
      immediate: true
    }
  },

  provide() {
    return {
      Sortable,
      getWrapHeight: () => this.wrapHeight,
      getListPageId: () => this.widget.options.relateId,
      getRawRelateId: () => this.rawRelateId
    };
  },

  mounted() {
    this.isMounted = true;
    this.afterMountedExecutoryFn.map((fn) => fn());
    this.afterMountedExecutoryFn = [];
  },
  beforeDestroy() {
    console.log("beforeDestroy");
    if (!this.isPreviewState) {
      delete cacheTableOptions[this.widget.options.relateId];
    }
    console.log("beforeDestroy", cacheTableOptions);
  },

  methods: {
    formatterWidthOrHeightStyle(length, isHeight) {
      if (typeof length === "string") length = length.trim();
      if (/^\d+$/.test(length)) {
        return `${length}px`;
      } else if (/^\d+px?$/.test(length)) {
        return length;
      } else if (/^\d+%?$/.test(length)) {
        if (isHeight) {
          return length.replace("%", "vh");
        } else {
          return length;
        }
      } else {
        console.warn("输入的高度或者宽度格式不正确！");
        return "";
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
